/* eslint-disable @typescript-eslint/no-floating-promises */
import GetAppIcon from "@mui/icons-material/GetApp";
import { Button } from "@mui/material";
import * as Cesium from "cesium";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  setCesiumPopupPosition,
  setHoveredCesiumItem,
  setSelectedCesiumItem,
} from "~/redux/reducers/mapReducer";
import { useAppDispatch, useAppSelector } from "~/redux/store/store";
import { GenericPopup } from "../../popups/GenericPopup";
import { useCesiumTilesetLoader } from "../hooks/useCesiumTilesetLoader";
import { CesiumMeasurementItem } from "../types/CesiumMapItems";

type Props = { viewer: Cesium.Viewer } & (ClickProps | HoverProps);

type ClickProps = {
  clickData: CesiumMeasurementItem;
  hoverData?: CesiumMeasurementItem;
};

type HoverProps = {
  hoverData: CesiumMeasurementItem;
  clickData?: CesiumMeasurementItem;
};

export const CesiumMeasurementPopup = ({
  viewer,
  hoverData,
  clickData,
}: Props): JSX.Element | null => {
  const { t } = useTranslation("cesium");
  const dispatch = useAppDispatch();
  const loadingIds = useAppSelector((s) => s.map.loadingTilesets);
  const changed = useAppSelector((s) => s.map.cesiumPrimitivesChanged);

  const { loader, tileset } = useCesiumTilesetLoader();

  useEffect(() => {
    if (tileset) {
      dispatch(setCesiumPopupPosition(undefined));
      dispatch(setSelectedCesiumItem(undefined));
      dispatch(setHoveredCesiumItem(undefined));
    }
  }, [changed, dispatch, tileset]);

  const data = clickData ?? hoverData;

  if (!data) return null;

  const { name, files } = data;

  return (
    <GenericPopup
      clicked={!!clickData}
      avatarText={name[0]}
      title={name}
      subheader=""
      content={
        <Button
          endIcon={<GetAppIcon />}
          variant="contained"
          color="secondary"
          disabled={
            !files?.length || files.some((f) => loadingIds?.includes(f.id))
          }
          onClick={() => {
            if (!files?.length) return;
            files.forEach((f) => {
              loader({
                file: f,
                markerMapId: data.mapId,
                viewer,
                projection: data.coordinateSystem?.name ?? "",
                seaSurvey: data,
              });
            });
          }}
        >
          {t("download")}
        </Button>
      }
    />
  );
};
